import React from 'react';
import Toolbar from '@material-ui/core/Toolbar';
import {
  List,
  Datagrid,
  Edit,
  Create,
  SimpleForm,
  TextField,
  TextInput,
  ExportButton,
  Filter,
  EditButton,
  CreateButton,
  required,
} from 'react-admin';
const CodeFilter = (props) => (
  <Filter {...props}>
      <TextInput label="Skill" source="skill" alwaysOn />
  </Filter>
);

const LanguageSkillActions = props => {
  const {
    filters,
    showFilter,
    resource,
    displayedFilters,
    filterValues,
    currentSort,
    total,
    exporter,
    basePath,
  } = props;

  return (
    <Toolbar>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button',
        })}
      <ExportButton
        disabled={total === 0}
        resource={resource}
        sort={currentSort}
        filter={filterValues}
        exporter={exporter}
        maxResults={total}
      />
      <CreateButton basePath={basePath} />
    </Toolbar>
  );
};

export const LanguageSkillList = props => (
  <List {...props} filters={<CodeFilter/>} actions={<LanguageSkillActions props={props} />}>
    <Datagrid optimized>
      <TextField label="ID" source="id" />
      <TextField label="Skill" source="skill" />
      <EditButton />
    </Datagrid>
  </List>
);

const LanguageSkillTitle = ({ record }) => {
  const { level } = record;
  return <span>LanguageSkill {record ? `"${level}"` : ''}</span>;
};

export const LanguageSkillEdit = props => (
  <Edit title={<LanguageSkillTitle />} {...props}>
    <SimpleForm>
      <TextField label="ID" source="id" />
      <TextInput label="Name" source="name" validate={[required()]} />
      <TextInput label="Skill" source="skill" validate={[required()]} />
    </SimpleForm>
  </Edit>
);

export const LanguageSkillCreate = props => (
  <Create {...props}>
    <SimpleForm>
        <TextField label="ID" source="id" />
        <TextInput label="Name" source="name" validate={[required()]} />
        <TextInput label="Skill" source="skill" validate={[required()]} />
    </SimpleForm>
  </Create>
);
